import React, { useState } from "react";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";
import "../styles/Help.css";

/* ─── Icons ─── */
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const ChevronDown = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const ChevronUp = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="18 15 12 9 6 15" />
  </svg>
);
const MailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
  </svg>
);
const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: false,path: "/dashboard" },
  { label: "Conversions", icon: <RepeatIcon />, active: false,path: "/conversions" },
  { label: "Payments", icon: <CreditCardIcon />, active: false,path: "/payments" },
  { label: "Settings", icon: <SettingsIcon />, active: false,path: "/settings" },
  { label: "Help", icon: <HelpIcon />, active: true,path: "/help" },
];

const FAQS = [
  { q: "What file formats does ConvertPro support?", a: "ConvertPro supports over 200 file formats including PDF, DOCX, XLSX, PNG, JPG, WEBP, MP4, WebM, MP3, WAV, CSV, JSON, and many more. Visit our formats page for the complete list." },
  { q: "How do I upgrade or downgrade my plan?", a: "Navigate to Settings > Current Plan and click 'Change Plan'. You can upgrade or downgrade at any time — changes take effect at your next billing cycle." },
  { q: "Is there a file size limit for conversions?", a: "Free accounts have a 100MB limit per file. Pro Plan supports up to 2GB per file, and Enterprise plans offer unlimited file sizes." },
  { q: "How secure are my uploaded files?", a: "All files are encrypted in transit (TLS 1.3) and at rest (AES-256). Files are automatically deleted from our servers within 24 hours of conversion." },
  { q: "Can I use ConvertPro API for batch conversions?", a: "Yes! The Pro Plan includes API access with 100 requests/second. You can batch convert files programmatically using our REST API or SDK." },
  { q: "How do I cancel my subscription?", a: "Go to Settings > Danger Zone and click 'Delete Account', or navigate to Payments to manage your subscription. You can cancel anytime with no penalty." },
];

/* ─── Sidebar ─── */
function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    const currentUser = JSON.parse(
      localStorage.getItem("currentUser") || "{}"
    );

    const initials =
      (
        currentUser.full_name ||
        currentUser.fullName ||
        ""
      )
        .split(" ")
        .map(name => name.charAt(0))
        .join("")
        .substring(0, 2)
        .toUpperCase() || "U";

    const handleLogout = () => {
                  localStorage.removeItem("currentUser");
                  localStorage.removeItem("selectedPlan");
                  navigate("/");
                };

  return (
    <aside className="hp-sidebar">
      <div className="hp-sidebar-upper">
        <div className="hp-profile">
          <div className="hp-avatar">
            {initials}
          </div>

          <div className="hp-profile-info">
            <span className="hp-profile-name">
              {currentUser.full_name ||
                currentUser.fullName ||
                "User"}
            </span>

            <span className="hp-profile-role">
              {currentUser.email || ""}
            </span>
          </div>
        </div>
        <nav className="hp-nav">
          {NAV_ITEMS.map((item) => (
                                                      <Link
                                                        key={item.label}
                                                        to={item.path}
                                                        className={`db-nav-item ${
                                                          location.pathname === item.path
                                                            ? "db-nav-item--active"
                                                            : ""
                                                        }`}
                                                      >
                                                        <span className="db-nav-icon">
                                                          {item.icon}
                                                        </span>
                                                        {item.label}
                                                      </Link>
                                                    ))}
                                                {/* ─── Logout separator + button ─── */}
                                                                                                                              <div className="db-nav-separator" />
                                                                                                                              <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                                                                                                                <span className="db-nav-icon">
                                                                                                                                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                                                                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                                                                                                    <polyline points="16 17 21 12 16 7" />
                                                                                                                                    <line x1="21" y1="12" x2="9" y2="12" />
                                                                                                                                  </svg>
                                                                                                                                </span>
                                                                                                                                Log Out
                                                                                                                              </button>
        </nav>
      </div>
    </aside>
  );
}

/* ─── Main Content ─── */
function MainContent() {
  const [openFaq, setOpenFaq] = useState(0);
  const [search, setSearch] = useState("");

  return (
    <main className="hp-main">
      {/* Page Header */}
      <div className="hp-page-header">
        <div>
          <h1 className="hp-page-title">Help & Support</h1>
          <p className="hp-page-sub">Find answers, explore guides, and get in touch with our team</p>
        </div>
        <Link
          to="/feedback"
          className="hp-btn-primary"
        >
          Contact Support
        </Link>
      </div>

      {/* Search Bar */}
      <div className="hp-search-bar">
        <SearchIcon />
        <input
          className="hp-search-input"
          type="text"
          placeholder="Search for help articles, guides, and FAQs..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* FAQ */}
      <div className="hp-card">
        <div className="hp-card-header">
          <h4>Frequently Asked Questions</h4>
          <p>Find immediate resolutions to common questions about ConvertPro</p>
        </div>
        <div className="hp-divider" />
        {FAQS.map((faq, i) => (
          <React.Fragment key={i}>
            <button
              className={`hp-faq-row ${openFaq === i ? "hp-faq-row--open" : ""}`}
              onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
            >
              <span className="hp-faq-q">{faq.q}</span>
              {openFaq === i ? <ChevronUp /> : <ChevronDown />}
            </button>
            {openFaq === i && (
              <div className="hp-faq-answer">
                <p>{faq.a}</p>
              </div>
            )}
            {i < FAQS.length - 1 && <div className="hp-divider" />}
          </React.Fragment>
        ))}
      </div>

      {/* Contact + Status */}
      <div className="hp-two-col">
        {/* Contact Us */}
        <div className="hp-card">
          <div className="hp-card-header">
            <h4>Contact Us</h4>
            <p>Can't find what you need? Reach out directly.</p>
          </div>
          <div className="hp-divider" />
          <div className="hp-contact-row"><MailIcon /><span>support@convertpro.in</span></div>
          <div className="hp-contact-row"><ClockIcon /><span>Mon–Fri, 9AM–6PM PST</span></div>
          <Link
          to="/feedback"
          className="hp-btn-primary"
          >
          Send a Message
          </Link>
        </div>
      </div>
    </main>
  );
}

/* ─── Help Page ─── */
export default function ConvertProHelp() {
  return (
    <div className="hp-layout">
      <Sidebar />
      <MainContent />
    </div>
  );
}
